import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CreateICDRequest, requestICD } from '../../models/symtomChecker/symptomsChecker';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from '../../generic/phrutills.service';
import { TranslateService } from '@ngx-translate/core';
import { SymptomsCheckerService } from 'src/app/services/symptoms-checker.service';
@Component({
  selector: 'app-visit-reason',
  templateUrl: './visit-reason.component.html',
  styleUrls: ['./visit-reason.component.css']
})
export class VisitReasonComponent implements OnInit {
  visitReason: string;
  patientpersonalinfo: any;
  wordCounter: any = 0;
  isvisitReasonEnter: boolean=false;
  visitDate: any;
  constructor(private route: Router, private spinner: NgxSpinnerService, private _phrutilService: PhrutillsService, private translateService: TranslateService,
private SymptomsCheckerService: SymptomsCheckerService) {
    let info = localStorage.getItem('PersonalInfo');
    if (!info) {
      this.route.navigateByUrl("/");
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PersonalInfo'));
    console.log(this.patientpersonalinfo);
  }
  profileForm = new FormGroup({
    visitreason: new FormControl('', [Validators.required]),

  });

  ngOnInit(): void {
    this._phrutilService.patientlanguage$.subscribe(language => {
      if (language === 'es') {
        this._phrutilService.setTitle('Razón de la visita');
      } else if (language === 'hi') {
        this._phrutilService.setTitle('यात्रा का कारण');
      }
      else if (language === 'ur') {
        this._phrutilService.setTitle('وزٹ کی وجہ');
      }
      else {
        this._phrutilService.setTitle('Reason for Visit');
      }
    });
    const reason = localStorage.getItem("visitReason")
    //console.log(reason);
    if (reason) {
      this.profileForm.controls['visitreason'].setValue(this._phrutilService.decrypt(reason));
      this.isvisitReasonEnter = true;
    }

  }
  backclick() {
    this.route.navigateByUrl("patient/insurance");
  }
  nextClick() {
    if (this.profileForm.valid) {
     const reasonValue = this.profileForm.controls['visitreason'].value;
      this.visitReason = this._phrutilService.encrypt(reasonValue)
      localStorage.setItem("visitReason", this.visitReason);
      this.route.navigateByUrl('patient/intake');
    } else {
      this.profileForm.markAllAsTouched();
    }
  
  }
  /*
  CreateICDRequest: any;
  submitReason() {
    if (this.profileForm.valid) {
      this.visitReason = this.profileForm.controls['visitreason'].value;
      console.log(this.visitReason);
      let request: any = new requestICD();
      this.visitDate = localStorage.getItem('visitDate')
      if (this.visitDate) {
        request.DOS = localStorage.getItem('visitDate');
      } else {
        //request.DOS = this.InitialQuestionResponce.result.DOS;
      }
      request.ICDS = "";
      request.SUMMARY = this.visitReason;
      request.DOB = this.patientpersonalinfo.DOB;
      request.PROVIDER_CODE = this.patientpersonalinfo.PROVIDER_CODE;
      request.PRACTICE_CODE = this.patientpersonalinfo.PRACTICE_CODE;
      request.TRANSACTION_ID = 0;
      request.PATIENT_ACCOUNT = this.patientpersonalinfo.PATIENT_ACCOUNT;
      request.CREATED_DATE = this.visitDate;
      request.MODIFIED_DATE = this.visitDate;
      //request.ROS_CAT_WITH_SYM = [];
      request.DELETED =  0;
      request.R_CODES = "";
      request.DIP_HTML = '',
      request.RISK_HTML = '';
      request.SYM_TO_ROS = '';
      //request.encounter_id = 0;
      this.CreateICDRequest = new CreateICDRequest();
      this.CreateICDRequest.request.push(request);
      this.spinner.show();

      let lang = localStorage.getItem('language');
      if (!lang)
        lang = 'en';

      this.SymptomsCheckerService.IcdPredictionSaveData(this.CreateICDRequest, lang).subscribe((res: any) => {
        this.spinner.hide();
        console.log(res);
        //comment success message on next page
        //this.phrUtils.showSuccess(res.RESPONSE.message);
        localStorage.setItem("backFromCovid", "false");
        this.route.navigateByUrl('patient/intake');
      }, (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this.phrUtils.showError("Service is not available, please try later.");
      });
    } else {
      this.profileForm.markAllAsTouched();
    }
   
  }*/
  CheckLength(feedbackText: string) {
    this.wordCounter = feedbackText.trim().length;
    if (feedbackText.trim().length > 0) {
      this.isvisitReasonEnter = true;
    } else {
      this.isvisitReasonEnter = false;
    }
  }
 
}
